import fontawesome from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-pro-regular/faAngleRight';
import faAngleLeft from '@fortawesome/fontawesome-pro-regular/faAngleLeft';
import faTimes from '@fortawesome/fontawesome-pro-regular/faTimes';
import faPlusSquare from '@fortawesome/fontawesome-pro-regular/faPlusSquare';
import faPencil from '@fortawesome/fontawesome-pro-regular/faPencil';
import faClock from '@fortawesome/fontawesome-pro-regular/faClock';
import faCalendarAlt from '@fortawesome/fontawesome-free-solid/faCalendarAlt';
import faCalendarAltReg from '@fortawesome/fontawesome-pro-regular/faCalendarAlt';
import faCommentAltReg from '@fortawesome/fontawesome-pro-regular/faCommentAlt';
import faCircle from '@fortawesome/fontawesome-pro-regular/faCircle';
import faRepeatAlt from '@fortawesome/fontawesome-pro-regular/faRepeatAlt';
import faCircleSolid from '@fortawesome/fontawesome-free-solid/faCircle';
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle';
import faCerticicate from '@fortawesome/fontawesome-free-solid/faCertificate';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
import faKeyboard from '@fortawesome/fontawesome-free-solid/faKeyboard';
import faChevronCircleLeft from '@fortawesome/fontawesome-free-solid/faChevronCircleLeft';
import faVideo from '@fortawesome/fontawesome-free-solid/faVideo';
import faVideoSlash from '@fortawesome/fontawesome-free-solid/faVideoSlash';
import faMicrophone from '@fortawesome/fontawesome-free-solid/faMicrophone';
import faMicrophoneSlash from '@fortawesome/fontawesome-free-solid/faMicrophoneSlash';
import faPhoneSlash from '@fortawesome/fontawesome-free-solid/faPhoneSlash';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
import faMapMarkerAlt from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt';
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
import faFileAlt from '@fortawesome/fontawesome-free-solid/faFileAlt';
import faCheckSquare from '@fortawesome/fontawesome-free-solid/faCheckSquare';
import faSquare from '@fortawesome/fontawesome-free-solid/faSquare';
import faLock from '@fortawesome/fontawesome-free-solid/faLock';
import faRedoAlt from '@fortawesome/fontawesome-free-solid/faRedoAlt';
import faComment from '@fortawesome/fontawesome-free-solid/faComment';
import faCheckCircle from '@fortawesome/fontawesome-free-solid/faCheckCircle';
import faTimesCircle from '@fortawesome/fontawesome-free-solid/faTimesCircle';
import faPencilAlt from '@fortawesome/fontawesome-free-solid/faPencilAlt';
import faImage from '@fortawesome/fontawesome-free-solid/faImage';
import faBuilding from '@fortawesome/fontawesome-free-solid/faBuilding';
import faFolder from '@fortawesome/fontawesome-free-solid/faFolder';
import faCube from '@fortawesome/fontawesome-free-solid/faCube';
import faStar from '@fortawesome/fontawesome-free-solid/faStar';
import faClipboardCheck from '@fortawesome/fontawesome-free-solid/faClipboardCheck';
import faUserClock from '@fortawesome/fontawesome-free-solid/faUserClock';
import faDollarSign from '@fortawesome/fontawesome-free-solid/faDollarSign';
import faAddressCard from '@fortawesome/fontawesome-free-solid/faAddressCard';
import faCogs from '@fortawesome/fontawesome-free-solid/faCogs';
import faCaretRight from '@fortawesome/fontawesome-free-solid/faCaretRight';
import faTrashAlt from '@fortawesome/fontawesome-pro-regular/faTrashAlt';

fontawesome.library.add(
    faAngleLeft,
    faCircle,
    faCircleSolid,
    faPhone,
    faQuestionCircle,
    faCheck,
    faCerticicate,
    faAngleRight,
    faPlay,
    faVideo,
    faVideoSlash,
    faMicrophone,
    faMicrophoneSlash,
    faPhoneSlash,
    faUser,
    faMapMarkerAlt,
    faEnvelope,
    faFileAlt,
    faCheckSquare,
    faSquare,
    faLock,
    faRedoAlt,
    faComment,
    faTimes,
    faPlusSquare,
    faPencil,
    faClock,
    faCalendarAlt,
    faCalendarAltReg,
    faCommentAltReg,
    faKeyboard,
    faChevronCircleLeft,
    faCheckCircle,
    faTimesCircle,
    faRepeatAlt,
    faPencilAlt,
    faImage,
    faBuilding,
    faFolder,
    faCube,
    faStar,
    faClipboardCheck,
    faUserClock,
    faDollarSign,
    faAddressCard,
    faCogs,
    faCaretRight,
    faTrashAlt
);



// WEBPACK FOOTER //
// ./src/js/icons/iconLibrary.js